import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const ChemistIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6 2.5V6.87834C6 6.92334 6 6.94585 5.99527 6.96721C5.99107 6.98617 5.98413 7.00441 5.97468 7.02136C5.96402 7.04047 5.94907 7.05729 5.91917 7.09093L2.64054 10.7794C2.22792 11.2436 2 11.8431 2 12.4641C2 13.8647 3.13535 15 4.53587 15H11.4641C12.8647 15 14 13.8647 14 12.4641C14 11.8431 13.7721 11.2436 13.3595 10.7794L10.0808 7.09093C10.0509 7.05729 10.036 7.04047 10.0253 7.02136C10.0159 7.00441 10.0089 6.98617 10.0047 6.96721C10 6.94585 10 6.92334 10 6.87834V2.5H10.5C10.7761 2.5 11 2.27614 11 2V1.5C11 1.22386 10.7761 1 10.5 1H5.5C5.22386 1 5 1.22386 5 1.5V2C5 2.27614 5.22386 2.5 5.5 2.5H6ZM8.5 2.5H7.5V7L4.80018 10.5998C5.52997 10.2356 6.69163 10 8 10C9.30837 10 10.47 10.2356 11.1998 10.5998L8.5 7V2.5Z"
		></path>
	</svg>
))
